/* eslint-disable @typescript-eslint/naming-convention */

import { pxToRem } from '@astro-ui/utils/helpers'

export const spacesValue = {
  xxsm: 2,
  xsm: 4,
  sm: 6,
  smd: 8,
  md: 10,
  mlg: 12,
  lg: 16,
  xlg: 18,
  xl: 20,
  '2xl': 24,
  '3xl': 32,
  '4xl': 36,
  '5xl': 40,
  '6xl': 42,
  '7xl': 44,
  '8xl': 48,
  '9xl': 56,
  '10xl': 64,
  '11xl': 72,
  '12xl': 80,
  '13xl': 88,
  '14xl': 128,
}

const spacesIndex: { [key: number]: number } = {}
Object.keys(spacesValue).forEach((key, index) => {
  spacesIndex[index] = spacesValue[key as keyof typeof spacesValue]
})

const spaces = { ...spacesIndex, ...spacesValue }

export const spacing = (key: SpacerKeyType) => pxToRem(spaces[key])

export type SpacerKeyType = keyof typeof spaces
